module.exports = __webpack_public_path__ + "img/Screens.88a31919.jpg";